module.exports = function() {

    let $open = $("#online_open"),
        $lx = $("#online_lx"),
        $close = $("#online_close"),
        $weixin = $("#sweixin"),
        $go = $("#gotop"),
        $fixed = $("#fixed_weixin");

    $open.click(function() {

        $(this).velocity({ right: '-200px' }, {
            easing: "ease",
            complete: function() {
                $lx.velocity({ right: '0px' }, { easing: "ease" });
            }
        });
    });

    $close.click(function() {

        $lx.velocity("reverse", {
            complete: function() {
                $open.velocity("reverse");
            }
        });

    });

    $("#sweixin, #fixed_weixin").click(function(e) {

        $fixed.toggleClass("show");

    });

    $("#fixed_weixin > .fixed-container").click(function(e) {

        e.stopPropagation();

    });

    $go.click(function() {

        $("html,body").animate({ scrollTop: 0 }, 500);

    });

    $(window).scroll(() => {

        const scrollTop = $(window).scrollTop();

        if (scrollTop === 0) {
            $go.hide();
        }

        if (scrollTop > 150) {
            $go.show();
        }

    });

};


// WEBPACK FOOTER //
// ./js/plugins/fixed.js